var React = require('react');

function EllipsisVerticalSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"white","d":"M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"}));
}

EllipsisVerticalSolid.defaultProps = {"viewBox":"0 0 128 512"};

module.exports = EllipsisVerticalSolid;

EllipsisVerticalSolid.default = EllipsisVerticalSolid;
